import { useTranslation } from 'react-i18next';
import { ColumnDef } from '@tanstack/react-table';
import { TableCell } from '@anytag/shared-atoms';
import { formatIntNumber } from '@anytag/shared-utils';
import { usePostDetailsParam } from '@anytag/shared-hooks';
import { InstagramFeedPostSortField, InstagramInteractionTaggedPost } from '@anytag/graphql';

export const useAnalyticsInstagramTaggedPostsListTable = () => {
  const { t } = useTranslation();
  const { setPostDetailsParam } = usePostDetailsParam();

  const columns: ColumnDef<InstagramInteractionTaggedPost>[] = [
    {
      accessorKey: 'post',
      meta: { sticky: true },
      header: t<string>('HeaderColumn.Post'),
      cell: ({ row }) => (
        <TableCell.Post
          title={row.original.content || ''}
          thumbnail={row.original.thumbNail || ''}
          onClick={() => setPostDetailsParam(row.original.id)}
        />
      )
    },
    {
      accessorKey: 'likes',
      header: t<string>('HeaderColumn.Like'),
      meta: { align: 'right', sortField: InstagramFeedPostSortField.LIKE },
      cell: ({ row }) => <TableCell.Number className="min-w-37.5" value={formatIntNumber(row.original.likes)} />
    },
    {
      accessorKey: 'comments',
      header: t<string>('HeaderColumn.Comment'),
      meta: { align: 'right', sortField: InstagramFeedPostSortField.COMMENT },
      cell: ({ row }) => <TableCell.Number className="min-w-37.5" value={formatIntNumber(row.original.comments)} />
    },
    {
      accessorKey: 'postDate',
      header: t<string>('HeaderColumn.Post date'),
      meta: { sortField: InstagramFeedPostSortField.POST_DATE },
      cell: ({ row }) => <TableCell.Date className="min-w-20" value={row.original.postDate} />
    }
  ];

  return { columns };
};
